// ── Parsing de chemins internes (i18n, segments) ──────────────────────────

/**
 * Retire le préfixe i18n `/en` ou `/es` pour analyser le segment métier.
 * @param {string} path Chemin commençant par `/`.
 * @returns {string} Chemin sans préfixe locale.
 */
export function stripLocalePrefix(path: string): string {
  const match = /^\/(en|es)(\/|$)/.exec(path)
  if (!match) return path
  const rest = path.slice(match[0].length)
  return rest.length > 0 ? (rest.startsWith('/') ? rest : `/${rest}`) : '/'
}

/**
 * @param {string} path Chemin interne (sans origin).
 * @returns {string | null} Premier segment URL ou `null` sur la home.
 */
export function getFirstPathSegment(path: string): string | null {
  const pathOnly: string = path.split('?')[0]?.split('#')[0] ?? '/'
  const withoutLocale: string = stripLocalePrefix(pathOnly)
  const segments: string[] = withoutLocale.split('/').filter(Boolean)
  return segments[0] ?? null
}
